import React, {useState} from 'react';
import t from '../../../helpers/t';

import {pricesActions} from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react
import {$} from "../../../../../vendor";
import {in_array} from "../../../../utils/Helper";
import PriceTypesSelect from "./behaviors/PriceTypesSelect";
import PricesTable from "./behaviors/PricesTable";


const Prices = (props) => {
    const { price, deletePrice, onChangePrice, dispatch, pricetypes, usedPriceTypes,setUsedPriceTypes,setAddPriceVisible, combineAblePricetypes,pricesCount} = props;
    let filteredArray=[1, 2, 3, 5,8, 15, 11, 16, 18, 19, 25, 24, 26, 27, 28, 29, 31, 32, 33, 34, 35];
    let timeBegin = [], timeEnd = [], weekdayBegin = "Mon", weekdayEnd ="Mon";
    let timeBeginHours = '00', timeEndHours = '00', timeBeginMinutes = '00', timeEndMinutes = '00';

    let hours = [],minutes =[];
    for(let i = 0; i < 24; i++){
        let a = i.toString();
        if(i < 10){
           a = '0' + i.toString();
        }
        hours.push(a);
    }
    for(let i = 0; i < 60; i++){
        let a = i.toString();
        if(i < 10){
            a = '0' + i.toString();
        }
        minutes.push(a);
    }
    const [priceLocal,setPriceLocal] = useState(price);
    const [weekdayPrice,setWeekdayPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && Number(priceLocal.pricetype_id) === 19));
    const [weekDailyPrice,setWeekDailyPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && Number(priceLocal.pricetype_id) === 35));
    const [weekEndPrice,setWeekEndPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && Number(priceLocal.pricetype_id) === 33));
    const [discountPrice,setDiscountPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && Number(priceLocal.pricetype_id) === 5));
    const [hiding,setHiding] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && Number(priceLocal.pricetype_id) === 32)
        ?{b:'weekday_price standard-price-column hide',
        a:'standard-price-column hide'}:{a:'standard-price-column',b:'weekday_price standard-price-column'});
    const [timeBasedPricetype, setTimeBasedPricetype] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && in_array(Number(priceLocal.pricetype_id),[1,2,3,16,24,26,34,18])));
    const [dayPrice, setDayPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && in_array(Number(priceLocal.pricetype_id),[2,26])));
    const [multipleUnitPrice, setMultipleUnitPrice] = useState((typeof priceLocal !== 'undefined' && priceLocal !== null && in_array(Number(priceLocal.pricetype_id),[15,29])));

    if(priceLocal !== null && typeof priceLocal.validWeekDays !== 'undefined' && priceLocal.validWeekDays !== null){
        let days = priceLocal.validWeekDays.split(',');
        weekdayBegin = days[0];
        weekdayEnd = days[1];
    }
    if(priceLocal !== null && typeof priceLocal.validTimes !== 'undefined' && priceLocal.validTimes !== null){
        let times = priceLocal.validTimes.split(',');
        timeBegin = times[0].split(':');
        timeBeginHours = timeBegin[0];
        timeBeginMinutes = timeBegin[1];
        timeEnd = times[1].split(':');
        timeEndHours = timeEnd[0];
        timeEndMinutes = timeEnd[1];
    }



    const onChangePricetype = (item) => {
        let clone = {};
        Object.assign(clone, priceLocal);
        if(Number(item.target.value) === 0){
            return;
        }
        if(Number(item.target.value) === 19){
            setWeekdayPrice(true);
        } else {
            setWeekdayPrice(false);
        }
        if(Number(item.target.value) === 35){
            setWeekDailyPrice(true);
        } else {
            setWeekDailyPrice(false);
        }
        if(Number(item.target.value) === 33){
            setWeekEndPrice(true);
        } else {
            setWeekEndPrice(false);
        }
       /* if(Number(item.target.value) === 31){
            setUVPPrice(true);
        } else {
            setUVPPrice(false);
        }*/
        if(Number(item.target.value) === 5){
            setDiscountPrice(true);
        } else {
            setDiscountPrice(false);
        }
        if(in_array(Number(item.target.value),[2,26])){
            setDayPrice(true);
        } else {
            setDayPrice(false);
        }
        if(in_array(Number(item.target.value),[15,29])){
            setMultipleUnitPrice(true);
        } else {
            setMultipleUnitPrice(false);
        }
        if(Number(item.target.value) === 32){
            setHiding({b:'weekay_price standard-price-column hide v',
                a:'standard-price-column hide'});
            clone.amount = 0;
            clone.pricetype_id = Number(item.target.value);
            $('.v').val(0);
            setTimeout(() => {
                setPriceLocal(clone);
            },10);
        } else {
            setHiding({a:'standard-price-column',b:'weekday_price standard-price-column'});
        }

        clone.pricetype_id = Number(item.target.value);
        setTimeBasedPricetype(in_array(Number(clone.pricetype_id),[1,2,3,5,16,24,26,34,18]));
        setTimeout(() => {
         setPriceLocal(clone);
        },10);
        setTimeout(() => {
            onChangePrice(clone);
        },10);
        checkPricetypes(usedPriceTypes, 'onChangePricetype');
    };

    const checkPricetypes = (used,where) => {

        let count = 0, count2 = 0;
        let newPricetypes = [];
        pricetypes.map(pricetype => {
            if ((used.length > 0 && in_array(pricetype.id, combineAblePricetypes) || priceLocal.pricetype_id === pricetype.id || used.length <= 0 || pricesCount <= 1)) {
                let combineAble = true;
                if (used.length > 1) {
                    used.map(uPT => {
                        if (!in_array(uPT, combineAblePricetypes) && uPT !== priceLocal.pricetype_id) {
                            combineAble = false;
                        }
                    })
                }
                if (combineAble && in_array(pricetype.id, filteredArray) && ((pricetype.id === 34 && Biscuit.get('user.is_superuser') === 'true') || pricetype.id !== 34)) {
                    if(!in_array(pricetype.id, usedPriceTypes)) {
                        count++;
                    }
                    newPricetypes.push(pricetype);
                }
            }
            if ((used.length > 0 && in_array(pricetype.id, combineAblePricetypes) || priceLocal.pricetype_id === pricetype.id || used.length <= 1)) {
                let combineAble = true;
                if (used.length > 0) {
                    used.map(uPT => {
                        if (!in_array(uPT, combineAblePricetypes)) {
                            combineAble = false;
                        }
                    });
                }
                if (combineAble && in_array(pricetype.id, filteredArray) && ((pricetype.id === 34 && Biscuit.get('user.is_superuser') === 'true') || pricetype.id !== 34)) {
                    if(!in_array(pricetype.id, usedPriceTypes)) {
                        count2++;
                    }
                }

            }
        });
        if(count2 < 1){
            setAddPriceVisible(false);
        } else {
            setAddPriceVisible(true);
        }
        return {
            count: count,
            pricetypes: newPricetypes
        };
    }

    const onChangeForm = (item) => {
        let clone = {};
        let ntimes;
        let weekdays
        Object.assign(clone, priceLocal);
        switch (item.target.name) {
            case 'amount':
                clone.amount = item.target.value;
                break;
            case 'amount_weekday_1':
                clone.amount_weekday_1 = item.target.value;
                break;
            case 'amount_weekday_2':
                clone.amount_weekday_2 = item.target.value;
                break;
            case 'amount_weekday_3':
                clone.amount_weekday_3 = item.target.value;
                break;
            case 'amount_weekday_4':
                clone.amount_weekday_4 = item.target.value;
                break;
            case 'amount_weekday_5':
                clone.amount_weekday_5 = item.target.value;
                break;
            case 'amount_weekday_6':
                clone.amount_weekday_6 = item.target.value;
                break;
            case 'amount_weekday_7':
                clone.amount_weekday_7 = item.target.value;
                break;
            case 'uvp':
                clone.percent_from_uvp = item.target.value;
                break;
            case 'min_units':
                clone.min_units = item.target.value;
                break;
            case 'first_unit_cost_free':
                clone.first_unit_cost_free = item.target.checked;
                break;
            case 'alternative_amount':
                clone.alternative_amount = item.target.value;
                break;
            case 'units':
                clone.units = item.target.value;
                break;
            case 'weekdays_begin':
                weekdayBegin = item.target.value;
                if(weekdayEnd !== ""){
                    weekdays = item.target.value + ',' + weekdayEnd;
                    clone.validWeekDays = weekdays;
                }
                break;
            case 'weekdays_end':
                weekdayEnd = item.target.value;
                if(weekdayBegin !== "") {
                    weekdays = weekdayBegin + ',' + item.target.value;
                    clone.validWeekDays = weekdays;
                }
                break;
            case 'times_begin_hour':
                timeBeginHours=item.target.value;
                ntimes = item.target.value + ':' + timeBeginMinutes + ',' + timeEndHours + ':' + timeEndMinutes;
                clone.validTimes = ntimes;
                break;
            case 'times_begin_minute':
                timeBeginMinutes=item.target.value;
                ntimes = timeBeginHours + ':' + item.target.value + ',' + timeEndHours + ':' + timeEndMinutes;
                clone.validTimes = ntimes;
                break;
            case 'times_end_hour':
                timeEndHours=item.target.value;
                ntimes = timeBeginHours + ':' + timeBeginMinutes + ',' + item.target.value + ':' + timeEndMinutes;
                clone.validTimes = ntimes;
                break;
            case 'times_end_minute':
                timeEndMinutes=item.target.value;
                ntimes = timeBeginHours + ':' + timeBeginMinutes + ',' + timeEndHours + ':' + item.target.value;
                clone.validTimes = ntimes;
                break;
        }

        setPriceLocal(clone);
        setTimeout(() => {
            onChangePrice(clone);
        },10);
    };



    const deletePriceLocal = () => {
        if (confirm(t('really_remove'))) {
           if(typeof priceLocal.id !== 'undefined') {
               dispatch(pricesActions.deletePrice(
                   {
                       id: Number(priceLocal.id),
                       token: Biscuit.get('token')
                   }
               ));
           }
            deletePrice(priceLocal);
        }
    };



    return(
        <>
            <div className="row medium-12 small-12" style={{marginTop: "20px",border: "1px solid hsl(0,0%,80%)"}} id={priceLocal?._uid}>

            <PriceTypesSelect
                onChangePricetype={onChangePricetype}
                usedPriceTypes={usedPriceTypes}
                priceLocal={priceLocal}
                checkPricetypes={checkPricetypes}
                />

               {/* {!UVPPrice && <div className="inb-form-group column medium-1 small-2 username">
                    <label className="inb-form__controlLabel">{t('price')}</label>
                    <div className="inb-form__controllClass">
                        <input id="price" type="text" className="form-control" name="price" required=""
                               autoComplete="false" placeholder="" value={price.amount}
                               onChange={(e) => onChangeForm(e, false)}/>
                    </div>
                </div>
                }
                {UVPPrice && <div className="inb-form-group column medium-1 small-2 username">
                    <label className="inb-form__controlLabel">{t('percent_from_uvp')}</label>
                    <div className="inb-form__controllClass">
                        <input id="percent_from_uvp" type="text" className="form-control" name="percent_from_uvp" required=""
                               autoComplete="false" placeholder="" value={price.percent_from_uvp}
                               onChange={(e) => onChangeForm(e, true)}/>
                    </div>
                </div>}*/}
                <div className="inb-form-group column medium-7 small-12 lang">
                    <PricesTable
                        timeBasedPricetype={timeBasedPricetype}
                        hiding={hiding}
                        multipleUnitPrice={multipleUnitPrice}
                        discountPrice={discountPrice}
                        dayPrice={dayPrice}
                        weekEndPrice={weekEndPrice}
                        weekdayPrice={weekdayPrice}
                        weekDailyPrice={weekDailyPrice}
                        priceLocal={priceLocal}
                        onChangeForm={onChangeForm}
                        weekdayBegin={weekdayBegin}
                        timeBeginHours={timeBeginHours}
                        hours={hours}
                        timeBeginMinutes={timeBeginMinutes}
                        minutes={minutes}
                        weekdayEnd={weekdayEnd}
                        timeEndHours={timeEndHours}
                        timeEndMinutes={timeEndMinutes}
                        />
                </div>
                <div className="inb-form-group column medium-1 small-2 lang">
                   {/* {!saved &&
                    <button type="button" className="inb-round-btn hollow round float-right" onClick={addPrice} style={{marginTop:"24px",marginRight:"6px",float:"left"}}>
                        <div className="inb-icon inb-fi-save" style={{width: "16px",height: "16px",marginLeft:"11px"}}></div>
                    </button>}*/}

                    <button type="button" className="inb-round-btn hollow round float-right" name={"delete_"+priceLocal?._uid} onClick={(e) => deletePriceLocal(e)} style={{marginTop:"24px",marginRight:"6px",float:"left"}}>
                        <div className="inb-icon inb-fi-remove" style={{width: "16px",height: "16px"}}></div>
                    </button>
                </div>
            </div>
        </>
    )

};


export default Prices;


